import React from "react";

import HomeIcon from "../../icons/home-icon";
import StudentIcon from "../../icons/student-icon";
import ResultIcon from "../../icons/result-icon";
import FinanceIcon from "../../icons/finance-icon";
import LibraryIcon from "../../icons/library-icon";

import lbl from "../../data/Labels.json";
import HRIcon from "../../icons/hr-icon";
import { isFinanceReadOnly, getProcurementExpensePaths } from "../../utils/financeAccess";

const basePath = "/mis";

export const getMain = () => {
  const items = [
    {
      id: 1,
      label: lbl.Stats,
      path: `${basePath}/stats`,
      icon: <HomeIcon />,
      section: "dashboard",
    },
    {
      id: 2,
      label: lbl.Students,
      path: `${basePath}/students`,
      icon: <StudentIcon />,
      section: "student",
    },
    {
      id: 3,
      label: lbl.Results,
      path: `${basePath}/results`,
      icon: <ResultIcon />,
      section: "exam",
    },
    {
      id: 6,
      label: lbl.Library,
      path: `${basePath}/books`,
      icon: <LibraryIcon />,
      section: "book",
    },
    {
      id: 4,
      label: lbl.HumanResources,
      path: `${basePath}/teachers`,
      icon: <HRIcon />,
      sections: ["teacher", "staff", "attendance"],
    },
    {
      id: 5,
      label: lbl.Finance,
      path: isFinanceReadOnly()
        ? `${basePath}/expenses/3`
        : `${basePath}/finance/dashboard/general?title=گزارشات`,
      icon: <FinanceIcon />,
      sections: ["finance-reports", "revenues", "fees", "expenses", "expense-budgets", "contractors", "benefits"],
    },
  ];

  if (isFinanceReadOnly()) {
    return items.filter((item) => item.id === 5);
  }

  return items;
};

export const getSub = () => {
  const items = [
    { name: lbl.Students, to: `${basePath}/students`, parent: 2, section: "student" },
    { name: lbl.Classes, to: `${basePath}/classes`, parent: 2, section: "class" },
    { name: lbl.Subjects, to: `${basePath}/subjects`, parent: 2, section: "subject" },
    { name: lbl.Timetable, to: `${basePath}/timetable`, parent: 2, section: "timetable" },
    { name: lbl.Applicants, to: `${basePath}/applicants`, parent: 2, section: "applicant" },

    { name: lbl.Faculties, to: `${basePath}/results`, parent: 3, section: "exam" },
    { name: "هشدار غیبت", to: `${basePath}/results/warnings`, parent: 3, section: "warnings" },

    { name: "لیست کتاب ها", to: `${basePath}/books`, parent: 6, section: "book" },
    { name: "امانت گیرندگان", to: `${basePath}/books/borrowed`, parent: 6, section: "book" },
    { name: lbl.Monographs, to: `${basePath}/monographs`, parent: 6, section: "book" },

    { name: lbl.Teachers, to: `${basePath}/teachers`, parent: 4, permission: "view-teachers-admin", section: "teacher" },
    { name: lbl.Staff, to: `${basePath}/staff`, parent: 4, permission: "view-staff-admin", section: "staff" },
    { name: "مدیریت حاضری", to: `${basePath}/attendance`, parent: 4, permission: "view-attendance-admin", section: "attendance" },

    {
      name: lbl.Report,
      to: `${basePath}/finance/dashboard/general`,
      parent: 5,
      section: "finance-reports",
    },
    { name: lbl.Revenues, to: `${basePath}/revenues/1`, parent: 5, section: "revenues" },
    { name: lbl.ExpenseAccounts, to: `${basePath}/expenses/1`, parent: 5, section: "expenses" },
    { name: "مصارف مستقیم", to: `${basePath}/expenses/3`, parent: 5, section: "expenses" },
    { name: "مصارف غیر مستقیم", to: `${basePath}/expenses/4`, parent: 5, section: "expenses" },
    { name: "بدهی ها", to: `${basePath}/expenses/5`, parent: 5, section: "expenses" },
  ];

  if (isFinanceReadOnly()) {
    const allowed = new Set(getProcurementExpensePaths());
    return items.filter((item) => allowed.has(item.to));
  }

  return items;
};

export default { getMain, getSub };
